import { CurrencyType } from '@repo/ui/src/types/general';

const getCurrencySymbol = (currency) => CurrencyType[currency] ?? '$';

export default getCurrencySymbol;
